import Component from '../../shared/component';
import throttle from '../../shared/throttle';

const SAVE_DELAY = 2000;

export default class LocallySavedTextInput extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    if (this.$element.disabled) return;

    this.$form = this.$element.closest('form');
    this.key = this.$element.data('locallySavedKey');

    this.bindEvents();
    this.setValueOnInput();
  }

  bindEvents() {
    this.handleText = throttle(this.handleText.bind(this), SAVE_DELAY);
    this.handleClearStorage = this.handleClearStorage.bind(this);

    this.$element.on('keyup', this.handleText);
    this.$form.on('submit', this.handleClearStorage);
  }

  unbindEvents() {
    this.$element.off('keyup', this.handleText);
    this.$form.off('submit', this.handleClearStorage);
  }

  handleText() {
    this.setValueOnStorage();
  }

  handleClearStorage() {
    localStorage.removeItem(this.key);
  }

  setValueOnInput() {
    const text = localStorage.getItem(this.key);
    if (text) this.$element.val(text);
  }

  setValueOnStorage() {
    const text = this.$element.val();
    localStorage.setItem(this.key, text);
  }
}
